/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGoCampaign_Counties.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   GoCampaign County Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, October 24, 2019 - 11:48:28 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      10/24/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const GOCAMPAIGNCOUNTY_LIST_CONTAINER_LOADED = 'GOCAMPAIGNCOUNTY_LIST_CONTAINER_LOADED';
export const GOCAMPAIGNCOUNTY_LIST_CONTAINER_UNLOADED = 'GOCAMPAIGNCOUNTY_LIST_CONTAINER_UNLOADED';
export const GOCAMPAIGNCOUNTY_LIST_TABLE_LOADED = 'GOCAMPAIGNCOUNTY_LIST_TABLE_LOADED';
export const GOCAMPAIGNCOUNTY_LIST_TABLE_UNLOADED = 'GOCAMPAIGNCOUNTY_LIST_TABLE_UNLOADED';

export const GOCAMPAIGNCOUNTY_LIST_CHANGE_GROUP = 'GOCAMPAIGNCOUNTY_LIST_CHANGE_GROUP';
export const GOCAMPAIGNCOUNTY_SELECT_ROW = 'GOCAMPAIGNCOUNTY_SELECT_ROW';

export const GOCAMPAIGNCOUNTY_ADD = 'GOCAMPAIGNCOUNTY_ADD';
export const GOCAMPAIGNCOUNTY_EDIT = 'GOCAMPAIGNCOUNTY_EDIT';
export const GOCAMPAIGNCOUNTY_DELETE = 'GOCAMPAIGNCOUNTY_DELETE';
export const GOCAMPAIGNCOUNTY_OPEN_WARNING = 'GOCAMPAIGNCOUNTY_OPEN_WARNING';
export const GOCAMPAIGNCOUNTY_CLOSE_WARNING = 'GOCAMPAIGNCOUNTY_CLOSE_WARNING';
export const GOCAMPAIGNCOUNTY_DELETE_DISABLE = 'GOCAMPAIGNCOUNTY_DELETE_DISABLE';
export const GOCAMPAIGNCOUNTY_VIEW_CHILD_ITEMS = 'GOCAMPAIGNCOUNTY_VIEW_CHILD_ITEMS';

export const GOCAMPAIGNCOUNTY_EDIT_CONTAINER_LOADED = 'GOCAMPAIGNCOUNTY_EDIT_CONTAINER_LOADED';
export const GOCAMPAIGNCOUNTY_EDIT_CONTAINER_UNLOADED = 'GOCAMPAIGNCOUNTY_EDIT_CONTAINER_UNLOADED';
export const GOCAMPAIGNCOUNTY_EDIT_FORM_LOADED = 'GOCAMPAIGNCOUNTY_EDIT_FORM_LOADED';
export const GOCAMPAIGNCOUNTY_EDIT_FORM_UNLOADED = 'GOCAMPAIGNCOUNTY_EDIT_FORM_UNLOADED';

export const GOCAMPAIGNCOUNTY_SET_GROUP_SELECT = 'GOCAMPAIGNCOUNTY_SET_GROUP_SELECT';
export const GOCAMPAIGNCOUNTY_EDIT_DATA_LOAD = 'GOCAMPAIGNCOUNTY_EDIT_DATA_LOAD';

export const GOCAMPAIGNCOUNTY_EDIT_CONTAINER_SUBMIT = 'GOCAMPAIGNCOUNTY_EDIT_CONTAINER_SUBMIT';
export const GOCAMPAIGNCOUNTY_EDIT_CONTAINER_CANCEL = 'GOCAMPAIGNCOUNTY_EDIT_CONTAINER_CANCEL';

export const GOCAMPAIGNCOUNTY_UPDATE_VALUE = 'GOCAMPAIGNCOUNTY_UPDATE_VALUE';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGoCampaign_Counties.js